/* eslint-disable no-unused-expressions */
/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

import { Button } from 'components/Button';
import CloseIcon from '@material-ui/icons/Close';
import { AuthContext } from 'providers/AuthProvider';
import {
  StyledDialog,
  Content,
  Header,
  CardContent,
  Card,
  CardRow,
  CircularCardNumber,
} from './styles';

// Modal de Login por link de email
const CalculationTooHighModal = ({ open, onClose, handleContinue }) => {
  const { currentUser } = useContext(AuthContext);
  const history = useHistory();

  const handleSendCustomerToLawyerWhatsapp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS Enviar pedido para o advogado');
    window.open(
      `https://api.whatsapp.com/send?phone=5511914498072&text=Ol%C3%A1,%20meu%20c%C3%A1lculo%20ficou%20acima%20de%2060%20sal%C3%A1rios%20e%20gostaria%20de%20pedir%20minha%20revis%C3%A3o%20${currentUser?.email}`,
      '_blank',
    );
  };

  return (
    <StyledDialog open={open} onClose={onClose}>
      <Content>
        <Header>
          <button onClick={onClose} type="button">
            <CloseIcon size={18} />
          </button>

          <h5>
            Importante: o valor do seu cálculo excede o limite do Juizado
            Especial Federal (JEF).
          </h5>

          <p>
            O cálculo da sua revisão apontou um valor muito interessante que
            ultrapassa os 60 salários mínimos (R$84.720,00) que é o teto para
            ações via Juizado Especial Federal (JEF).
          </p>
          <p>Isso significa que você tem duas opções:</p>
        </Header>

        <CardContent>
          <Card>
            <CardRow>
              <CircularCardNumber>1</CircularCardNumber>

              <p>
                <strong>
                  Seguir pelo JEF porém abrindo mão do valor excedente aos 60
                  salários mínimos;
                </strong>
                {' '}
                neste caso você pode seguir de maneira autônoma, sem advogado, e
                pode utilizar nosso KIT ou nosso serviço de atermação sem outros
                custos ao longo do processo.
              </p>
            </CardRow>

            <Button variant="contained" onClick={handleContinue}>
              Continuar com pedido via JEF
            </Button>
          </Card>

          <Card>
            <CardRow>
              <CircularCardNumber>2</CircularCardNumber>

              <p>
                <strong>
                  Seguir pela Justiça Federal comum através de um advogado
                </strong>
                {' '}
                especializado neste tema; neste caso
                {' '}
                <strong>
                  nós podemos direcionar o seu caso para um advogado credenciado
                  e não haverá custo inicial, somente quando ganhar a ação.
                </strong>
              </p>
            </CardRow>

            <Button
              variant="contained"
              onClick={handleSendCustomerToLawyerWhatsapp}
            >
              Enviar o pedido ao advogado
            </Button>
          </Card>
        </CardContent>

        <Button variant="text" onClick={() => history.push('/calculo')}>
          Voltar
        </Button>
      </Content>
    </StyledDialog>
  );
};

CalculationTooHighModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
};

export default CalculationTooHighModal;
